module.exports = __webpack_public_path__ + "media/images/pla/pla2-4597c23f70a222e91d5e5c21c2ba6fd7.jpg";